export async function modalPrompt(message, default_value="") {
    const buildModal = (msg) => {
        const modalHtml = `
                               <div class="modal-background"></div>
                               <div class="modal-card">
                                   <header class="modal-card-head">
                                       <p class="modal-card-title">Dialog</p>
                                       <button class="button close-modal is-ghost" aria-label="close">
                                           <span class="icon" style="{#  color: #1f1f1f; background: #436d89; border-radius: 100px;#}">
                                               <i class="fa fa-xmark"></i>
                                           </span> 
                                       </button>
                                   </header>
                                   <section class="modal-card-body">
                                       <p>
                                           ${msg}
                                       </p>
                                       <input type="text" class="input mt-2" name="prompt-input">
                                     <div class="field is-grouped is-grouped-right mt-3">
                                        <p class="control">
                                           <button type="button" class="button cancel">Cancel</button>
                                        </p>
                                        <p class="control">
                                           <button type="button" class="button is-success submit-value">Save</button>
                                        </p>
                                     </div>
                                   </section>
                                   <footer class="modal-card-foot">
                                   </footer>
                               </div>
                           `;
        const promptEl = document.createElement("div");
        promptEl.classList.add("modal", "modal-prompt", "is-active");
        promptEl.innerHTML = modalHtml;
        return promptEl;
    }
    const promptEl = buildModal(message);
    document.body.appendChild(promptEl);
    return new Promise((resolve, reject) => {
        promptEl.querySelector(".button.submit-value")?.addEventListener("click", () => {
            promptEl.remove()
            resolve(promptEl.querySelector("[name=prompt-input]")?.value || default_value)
        });
        promptEl.querySelectorAll(".button.cancel")?.forEach(el => {
            el.addEventListener("click", () => {
                promptEl.remove()
                resolve(default_value)
            });
        })
    })
}
